 <!-- _________ start footer _______ -->
 <footer class="footer py-5">
    <div class="container">
        <div class="footer-content col-lg-11 mx-auto">
            <div class="row no-gutters px-0 px-md-3">

                <div class="col-lg-3 mb-3 mb-lg-0">
                    <div class="col-box">
                        <div class="col-title">
                            <h6>
                                {{ 'Download_App_Now' | translate }}
                            </h6>
                        </div>
                        <div class="apps mb-3 mb-lg-4">
                            <a target="_blanck" class="mr-2 mb-2 d-inline-block google_play" href="https://apps.apple.com/us/app/qaysar-pizza-we-speak-pizza/id1531378175"><img src="assets/images/footer/Apple_Store.png" alt="Apple Store"></a>
                            <a target="_blanck" class="mr-2 mb-2 d-inline-block google_play" href="https://play.google.com/store/apps/details?id=com.qaysar.pizzaapp"><img src="assets/images/footer/google-play.png" alt="google play"></a>
                            <a target="_blanck" class="mr-2 mb-2 d-inline-block google_play" href="https://appgallery.huawei.com/#/app/C103236301"><img src="assets/images/footer/app-gallery.png" alt="App Gallery"></a>
                        </div>

                        <!-- accept cards -->
                        <div class="accept_cards d-flex align-items-center">
                            <span class="mr-3 accept">
                                {{ 'Accepts' | translate }} 
                            </span>
                            <div class="card_logos">
                                <img class="mr-2 odd" src="assets/images/global/visa.png" alt="Visa">
                                <img class="mr-2" src="assets/images/global/Mastercard.png" alt="Mastercard">
                            </div>
                        </div>

                    </div>
                </div>

                <div class="col-6 col-lg-4 mb-3 order-2 order-md-2 order-lg-2 mb-lg-0">
                    <div class="row">
                        <div class="col-lg mb-2 mb-lg-0">
                            <div class="col-box">
                                <div class="col-title">
                                    <h6>
                                        {{ 'Call_Center' | translate }}
                                    </h6>
                                </div>
                                <div class="call">
                                    <a class="mr-2 qaysar_phone hvr-icon-pulse-shrink"  href="tel:+065777888">
                                        <i class="fa fa-phone mr-1 hvr-icon" aria-hidden="true"></i>
                                        <span>{{ '065777888' | translate }}</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                     
                        <div class="col-lg mb-3 mb-lg-0 ">
                            <div class="col-box">
                                <div class="col-title">
                                    <h6>
                                        {{ 'Follow_us_on' | translate }}
                                    </h6>
                                </div>
                                <div class="social">
                                    <a target="_blanck" class="mr-2 facebook_link" href="https://www.facebook.com/QaysarPizza/"><i class="fa fa-facebook" aria-hidden="true"></i></a>
                                    <a target="_blanck" href="https://www.instagram.com/qaysarpizza/"><i class="fa fa-instagram"></i></a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-6 col-lg-5 mb-3 order-3 order-md-3 order-lg-3 mb-lg-0">
                    <div class="row">
                        <div class="col-lg-6 mb-lg-0">
                            <div class="col-box">
                                <div class="links">
                                    <ul class="list-unstyled mb-0">
                                        <li>
                                            <a class="mb-1" routerLink="/about-qaysar-pizza" routerLinkActive="active">
                                                {{ 'About_Qaysar_Pizza' | translate }} <span class="ml-1 pizza-slice">🍕</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a class="mb-1" routerLink="/have-a-complaint" routerLinkActive="active">
                                                {{ 'Have_a_complain?' | translate }} <span class="ml-1 pizza-slice">🍕</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a class="mb-1" routerLink="/careers" routerLinkActive="active">
                                                {{ 'Careers' | translate }} <span class="ml-1 pizza-slice">🍕</span>
                                           </a>
                                        </li>
                                        <li>
                                            <a class="mb-1" routerLink="/cancellation-policy" routerLinkActive="active">
                                                {{ 'footer.cancellation_policy' | translate }} <span class="ml-1 pizza-slice">🍕</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
        
                        <div class="col-lg-6 mb-lg-0">
                            <div class="col-box">
                                <div class="links">
                                    <ul class="list-unstyled mb-0">
                                        <li>
                                            <a class="mb-1" routerLink="/privacy-policy" routerLinkActive="active">
                                                {{ 'Privacy_Policy' | translate }} <span class="ml-1 pizza-slice">🍕</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a class="mb-1" routerLink="/terms-and-conditions" routerLinkActive="active">
                                                {{ 'Terms_&_Conditions' | translate }} <span class="ml-1 pizza-slice">🍕</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a class="mb-1" routerLink="/refund-policy" routerLinkActive="active">
                                                {{ 'footer.refund_policy' | translate }} <span class="ml-1 pizza-slice">🍕</span>
                                            </a>
                                        </li>
                                        <li>
                                            <a class="mb-1" routerLink="/delivery_policy_&_method" routerLinkActive="active">
                                                {{ 'footer.delivery_policy_&_method' | translate }} <span class="ml-1 pizza-slice">🍕</span>
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <hr class="hr-footer my-4">
            
            <!-- copyright -->
            <div class="copyright px-0 px-md-3">
                <div class="row row-copy no-gutters">
                    <small class="col-md-5 order-last order-md-first text-center">{{ 'Designed_&_Developed_by' | translate }}<a class="text-lowercase d-inline-block mx-1" href="http://www.wetriplea.com" target="_blank">triple a</a></small>
                    <small class="col-md-7 order-first order-md-last text-center">{{ 'Qaysar_Pizza_Co._-_All Rights_Reserved._2020' | translate }}</small>
                </div>
            </div>

        </div>
    </div>
</footer>
<!-- _________ end footer _______ -->
